<template>
  <NuxtLayout name="funnel">
    <ConnectifTag :name="CONNECTIF_PAGE_TAGS.DETAIL" />
    <ConnectifTag :name="CONNECTIF_CONTENT_TAGS.TRANSACTIONAL" />
    <ConnectifCategory :name="province" />
    <CottageContact
      v-if="cottageContactPage"
      :cottage-contact-page="cottageContactPage"
    />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { NUXT_PAGE_COTTAGE_CONTACT_NAME } from '~/modules/views/cottage-contact/constants'
import type { CottageContactPage } from '~/modules/views/cottage-contact/entities/CottageContactPage'

import type { HeadInfo } from '~/modules/head/entities/HeadInfo'
import { useHeadInfoComposable } from '~/modules/head/composables/useHeadInfoComposable'

// Constants
import {
  CONNECTIF_PAGE_TAGS,
  CONNECTIF_CONTENT_TAGS,
} from '~/modules/integrations/connectif/constants'

const { setHeadInfo } = useHeadInfoComposable()

const route = useRoute()

definePageMeta({
  name: NUXT_PAGE_COTTAGE_CONTACT_NAME,
  menuLogoBackHideLink: true,
})

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const setTitle = (cottage: CottageContactPage): string => {
  return t('views.cottage-contact.seo.title', { name: cottage.name })
}

const slug = route.params.slug as string
const province = route.params.province as string

const paramsCottage = { slug, province }

let cottageContactPage: CottageContactPage | null = null

const { data: cottageData } = await useFetch(
  '/__nuxt-api/rurality/v3/cottages/detail',
  {
    body: paramsCottage,
    method: 'POST',
  },
)

if (cottageData.value) {
  if (cottageData.value.success) {
    const getCottageCall = cottageData.value.success.data

    const paramsOwner = {
      id: getCottageCall.owner.id,
    }
    const { data: ownerData } = await useFetch(
      '/__nuxt-api/rurality/v3/owners/detail',
      {
        body: paramsOwner,
        method: 'POST',
      },
    )

    if (ownerData.value) {
      if (ownerData.value.success) {
        cottageContactPage = {
          ...getCottageCall,
          owner: ownerData.value.success.data,
        }
        const cottageHeadInfo: HeadInfo = {
          title: setTitle(cottageContactPage),
        }
        setHeadInfo(cottageHeadInfo)
      } else if (ownerData.value.error) {
        showErrorPage(ownerData.value.error as ApiResponseError)
      }
    }
  } else if (cottageData.value.error) {
    showErrorPage(cottageData.value.error as ApiResponseError)
  }
}
</script>
